import React, { useState, useRef, useEffect } from "react";
import { Beef, LogIn, ShieldCheck } from "lucide-react";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function LockScreen() {
  const { login } = useAuth();
  const [pin, setPin] = useState("");
  const [shake, setShake] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const submit = () => {
    const r = login(pin);
    if (r) {
      toast.success(`Signed in as ${r === "owner" ? "Owner" : "Staff"}`);
    } else {
      setShake(true);
      setTimeout(() => setShake(false), 500);
      setPin("");
      toast.error("Wrong PIN");
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-4" data-testid="lock-screen">
      <div className="w-full max-w-md">
        {/* Brand */}
        <div className="flex flex-col items-center gap-3 mb-10">
          <img
            src="/eeman-logo.jpg"
            alt="EEMAN MEATS"
            className="h-32 w-auto object-contain"
            data-testid="lock-logo"
          />
          <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">
            Accounting · POS
          </div>
        </div>

        <div className="border border-zinc-200 bg-white p-8">
          <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-1">
            Welcome
          </div>
          <h1 className="font-display text-3xl font-bold tracking-tighter mb-6">
            Enter PIN
          </h1>

          <input
            ref={inputRef}
            type="password"
            inputMode="numeric"
            autoComplete="off"
            placeholder="• • • •"
            value={pin}
            data-testid="lock-pin-input"
            onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            className={`w-full border border-zinc-300 px-4 py-4 text-3xl font-mono-num text-center tracking-[0.4em] focus:outline-none focus:ring-2 focus:ring-sky-600 ${
              shake ? "animate-pulse border-sky-600" : ""
            }`}
          />

          <button
            onClick={submit}
            data-testid="lock-submit-btn"
            className="w-full mt-4 bg-sky-600 text-white py-3 font-medium uppercase tracking-wider hover:bg-sky-700 flex items-center justify-center gap-2"
          >
            <LogIn className="h-4 w-4" />
            Unlock
          </button>

          <div className="mt-6 pt-6 border-t border-zinc-200 grid grid-cols-2 gap-4 text-xs">
            <div className="flex items-start gap-2">
              <ShieldCheck className="h-4 w-4 text-sky-600 mt-0.5" />
              <div>
                <div className="font-semibold uppercase tracking-wider text-[10px]">Owner</div>
                <div className="text-zinc-600">Full access — all reports, settings &amp; admin</div>
              </div>
            </div>
            <div className="flex items-start gap-2">
              <ShieldCheck className="h-4 w-4 text-zinc-700 mt-0.5" />
              <div>
                <div className="font-semibold uppercase tracking-wider text-[10px]">Staff</div>
                <div className="text-zinc-600">POS + Wholesale only</div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-[10px] text-zinc-500 text-center mt-6">
          Owner can change PINs in Settings after sign-in.
        </div>
      </div>
    </div>
  );
}
